


















































































import Table from '@/components/Table.vue'
import {
  getTopUpAgents,
  createAgentCredit,
  getTopUpAgentById,
} from '@/api/Topup/topup.api'
import { TableHeader } from '@/utils/interfaces'
import ActionButton from '@/components/ActionButton.vue'
import { TopUpAgent } from '@/utils/interfaces/topup.interface'
import { tableHandler } from '@/utils/mixins/tableHandler'
import UsersFilter from '@/components/Agency/Users/UsersFilter.vue'
import CreditEditDialogVue from '@/components/Services/TopUps/CreditEditDialog.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default tableHandler<TopUpAgent>().extend({
  components: {
    appTable: Table,
    appActionButton: ActionButton,
    appUsersFilter: UsersFilter,
    appCreditEditDialog: CreditEditDialogVue,
    appConfirmDialog: ConfirmDialog,
    FlatCard,
    FlatTable,
  },
  data() {
    return {
      myAgent: {} as {} | TopUpAgent,
      getter: getTopUpAgents,
      creatingItem: null as null | TopUpAgent,
      headers: [
        {
          text: this.$t('agent'),
          value: 'username',
        },
        {
          text: this.$t('credit') + ' ($)',
          value: 'topup_credit',
        },
        {
          text: this.$t('save'),
          value: 'actions',
        },
      ] as TableHeader[],
      loading: false,
      sign: 'plus',
      editedItem: null as null | TopUpAgent,
      description: '',
      confirmDialog: false,
    }
  },
  methods: {
    onDone(value: boolean) {
      if (value && this.creatingItem) {
        this.onCreate(this.creatingItem)
      } else {
        this.creatingItem = null
      }
    },
    async onModify(item: TopUpAgent, sign: 'minus' | 'plus'): Promise<void> {
      this.sign = sign
      this.editedItem = item
      this.dialogModel = true
    },
    async onCreate(item: TopUpAgent): Promise<void> {
      try {
        this.creatingItem = item
        if (item.topup_credit === null) {
          item.topup_credit = 0
        }
        const response = await createAgentCredit({
          ...item,
          description: this.description,
        })
        this.description = ''
        item = response
        this.table.refresh()
      } finally {
        this.creatingItem = null
      }
    },
  },
  async mounted() {
    try {
      this.loading = true
      const response = await getTopUpAgentById(this.$store.getters.profile.uuid)
      this.myAgent = response.data
    } finally {
      this.loading = false
    }
  },
})
